import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { FulfillmentGroupUpdate } from "@redotech/redo-merchant-fulfillment-rpc/schema/update-fulfillment-groups";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { NoteCell } from "../cells/note-cell";

const catalogEntry = fgColumnEntries["internal-notes"];

export const InternalNotesColumn = (
  handleUpdates: (updates: FulfillmentGroupUpdate[]) => void,
): Column2<FulfillmentGroupData> => ({
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => {
    return (
      <NoteCell handleUpdates={handleUpdates} kind="internalNote" row={row} />
    );
  },
  sort: catalogEntry.sortDirection,
  width: catalogEntry.defaultWidth,
  alignment: ColumnAlignment.LEFT,
});
